import { Injectable } from '@angular/core';
import { DbTableDefinition } from 'src/app/_services/persistence/db-persistence/db-table-definition';

@Injectable({
  providedIn: 'root',
})
export class LocalBranchFunctionGroupsDbTableDefinition extends DbTableDefinition {
  tableName = 'local_branchFunctionGroups';
  tableStructure = `(id INTEGER PRIMARY KEY AUTOINCREMENT,
     branchid BIGINT(20),
     functiongroupid BIGINT(20),
     databag LONGTEXT
    );`;

  constructor() {
    super();
    this.updateStatements.set(39, [
      `CREATE TABLE IF NOT EXISTS ${this.tableName}${this.tableStructure}`,
    ]);
  }
}
